class MainProductPrice extends HTMLElement {
    constructor() {
        super();
    }

    get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
    }

    connectedCallback() {
        document.addEventListener(
            'on:variant:change',
            this.handleOptionValueChange.bind(this)
        );
    }

    handleOptionValueChange({ detail }) {
        const { selectedOption } = detail;

        if (!selectedOption) {
            return;
        }

        const optionId = selectedOption.dataset.valueId;

        const productUrl = this.dataset.url;

        this.renderProductPrice({
            requestUrl: this.buildRequestUrlWithParams(productUrl, [optionId]),
            targetId: selectedOption.id,
        });
    }

    buildRequestUrlWithParams(url, optionValues) {
        const params = [];

        params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
    }

    setContent(html) {
        const element = html.getElementById(this.id);

        this.innerHTML = element.innerHTML;
    }

    renderProductPrice({ requestUrl, targetId }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                this.setContent(html);
            })
            .then(() => {
                // set focus to last clicked option value
                document.querySelector(`#${targetId}`)?.focus();
            })
            .catch((error) => {
                if (error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                } else {
                    console.error(error);
                }
            });
    }
}

if (!customElements.get('main-product-price-component')) {
    customElements.define('main-product-price-component', MainProductPrice);
}
